import { Button, Flex, Img, Text } from '@chakra-ui/react';
import React from 'react';
import { BsArrowUpRightCircle } from 'react-icons/bs';
// import { FiDownload } from 'react-icons/fi';

interface CardIProps {
  title: string;
  date?: string;
  desc: string;
  imgSrc: string;
  type?: string;
  readLink?: string;
}

const PerformanceCard: React.FC<CardIProps> = ({
  title,
  date,
  desc,
  imgSrc,
  type,
  readLink,
}) => (
  <Flex
    maxW={
      type === 'performance'
        ? { xs: '350px', sm: '450px', md: '512px' }
        : '360px'
    }
    h={type === 'performance' ? { xs: '370px', sm: '406px' } : 'auto'}
    flexDir="column"
    border="1px solid #EDEDED"
    boxShadow="lg"
    pos="relative"
    justify="space-between"
  >
    <Flex
      px="10px"
      pt="10px"
      w="100%"
      h={type === 'performance' ? { xs: '90px', sm: '123px' } : '100%'}
      bg="linear-gradient(107.03deg, #D5F5F0 44.35%, #A1F0E2 65.67%, #E8FFFB 87.91%)"
      alignItems={type === 'performance' ? 'center' : 'flex-start'}
      pl={type === 'performance' ? '40px' : '0px'}
    >
      <Img
        src={imgSrc}
        alt="rupee"
        w={type === 'performance' ? '30%' : '50%'}
        objectFit="cover"
      />
    </Flex>

    {type !== 'performance' && (
      <Img
        src="/svg/rupeeOverlay.svg"
        alt="rupeeOverlay"
        pos="absolute"
        px="10px"
        pt="10px"
      />
    )}

    <Flex flexDir="column" pl="28px" pr="25px" overflow="hidden" pt="20px">
      <Text
        fontSize="14px"
        fontWeight="800"
        color="#5d6fd0"
        letterSpacing="-0.02em"
      >
        {date}
      </Text>
      <Text variant="infoText" fontWeight="700" pt="13px">
        {title}
      </Text>
      <Text
        fontSize="14px"
        fontWeight="500"
        color="text.textBlue"
        noOfLines={4}
      >
        {desc}
      </Text>
    </Flex>
    <Flex
      borderTop="1px solid #DCE3E9"
      w="100%"
      alignItems="center"
      justifyContent="space-between"
      mt="16px"
    >
      <Button
        as="a"
        href={readLink}
        rel="noreferrer"
        target="_blank"
        bgColor="transparent"
        w={{ xs: '50%', sm: '40%' }}
        rightIcon={<BsArrowUpRightCircle size="20px" />}
        variant="cardButton"
        _active={{ color: 'text.green' }}
        _hover={{ color: 'text.green' }}
      >
        Read more
      </Button>
    </Flex>
  </Flex>
);

export default PerformanceCard;
